<template>
  <footer class="footer">
  <div class="container">
    <div class="content has-text-centered">
      <p>
        <strong>IceTiger.EU</strong> &#169; 2018 - 2024 by <a href="mailto:contact@icetiger.eu">IceTiger</a>&nbsp;<i class="fas fa-paw"></i>
        <br/>
        <strong>Informatiger.NET</strong> &#169; 2019 - 2024 by <a href="mailto:contact@icetiger.eu">IceTiger</a>&nbsp;<i class="fas fa-paw"></i>
      </p>
      <p><router-link to="/privacy">Privacy Policy and GDPR</router-link></p>
      <p>Font Icons by <a href="https://fontawesome.com/" title="Font Awesome">Font Awesome</a> | <a href="https://fontawesome.com/privacy" title="Privacy">Privacy</a></p>
      <p><button @click="gotoTop" class="button is-small"><i class="fas fa-chevron-up"></i>&nbsp;Top</button></p>
    </div>
   </div>
  </footer>
</template>

<script>
export default {
  name: 'FootBar',
  methods: {
    gotoTop: function(event) {
      scroll(0,0);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/footbar.vue